import { SkillOptionType } from 'components/SkillsSelectInput/SkillsSelectInput.types';
import { Skill } from 'types/graphql';

export const skillToOption = (
  skill: Pick<Skill, 'id' | 'displayId' | 'name'>,
): SkillOptionType => ({
  id: skill.id,
  key: skill.id,
  value: `${skill.displayId}`,
  label: skill.name,
  name: skill.name,
});
